import Vue from 'vue'
import Vuex from 'vuex'

import HRPersonelRequestModule from "@/store/modules/HRPersonelRequest.module"
import AuthModule from "@/store/modules/auth.module";
import PermissionModule from "@/store/modules/permission.module";
import DailyManualModule from '@/store/modules/DailyManual.module';

Vue.use(Vuex)
const store = new Vuex.Store();

store.registerModule("HRPersonelRequest", HRPersonelRequestModule);
store.registerModule("auth", AuthModule);
store.registerModule("permission", PermissionModule)
store.registerModule('DailyManual', DailyManualModule);

export default store
